<template>
	<div v-loading="loading" class="resumeDe">
		<div class="resumeDeCon" v-if="detail">
			
			<div v-if="type==2" class="head">
				<div class="left">
					<div class="name">
						{{detail.position_type}}
					</div>
					<div class="info">
						{{detail.living_place}} · {{detail.qualifications}} · {{detail.work_year}} · 
						 {{detail.type!=2?`${parseFloat((detail.salary_min/1000).toFixed(1))}-${parseFloat((detail.salary_max/1000).toFixed(1))}k`:detail.salary_part_time_job}}
						 · {{detail.type=='0'?'全职':detail.type=='1'?'实习':'兼职'}}
					</div>
				</div>
				<el-button type="primary" class="button" @click="openPosition">打开职位</el-button>
			</div>
			
			<div class="resume">
				<div class="info">
					<div class="basics">
						<div class="top">
							<div class="left">
								<div class="avatar">
									<el-image :src="detail.avatar" fit="cover" class="photo"></el-image>
									<img v-if="detail.sex==0" src="@/static/male.png" class="gender" />
									<img v-else src="@/static/female.png" class="gender" />
								</div>
								<div class="nameOcc">
									<div class="name">
										{{detail.user_name}}
									</div>
									<div class="occ">
										{{detail.position_type}}
									</div>
								</div>
							</div>
							<div class="right">
								<div class="li">
									<img src="@/static/yearIcon.png" class="icon" />
									<div>
										{{detail.work_year}}
									</div>
								</div>
								<div class="li">
									<img src="@/static/eduIcon.png" class="icon" />
									<div>
										{{detail.qualifications}}
									</div>
								</div>
								<div class="li">
									<img src="@/static/ageIcon.png" class="icon" />
									<div>
										{{detail.ages}}岁
									</div>
								</div>
							</div>
						</div>
						<div class="bottom">
							{{detail.personal_evaluation}}
						</div>
					</div>
				
				    <div class="model">
						<div class="left"> 实习/工作经历 </div>
						<div class="right">
							<div v-if="detail.work.length==0">未填写工作经历</div>
							<div v-for="(item,index) of detail.work" :key="index" class="li">
								<div class="cor">
									<div class="name">
										{{item.belong_to}}
										<span>{{item.position}}</span>
									</div>
									<div class="time">
										{{item.start_time}}至{{item.end_time}}
									</div>
								</div>
								<div class="praContent">
									工作内容：{{item.descrption}}
								</div>
								<div class="reason">
									离职原因：{{item.remark}}
								</div>
							</div>
						</div>
					</div>
					
					<div class="model">
						<div class="left"> 项目经历 </div>
						<div class="right">
							<div v-if="detail.project.length==0">未填写项目经历</div>
							<div v-for="(item,index) of detail.project" :key="index" class="li">
								<div class="cor">
									<div class="name">
										{{item.belong_to}}
										<span>{{item.position}}</span>
									</div>
									<div class="time">
										{{item.start_time}}至{{item.end_time}}
									</div>
								</div>
								<div class="praContent">
									项目描述：{{item.descrption}}
								</div>
								<div class="reason">
									备注：{{item.remark}}
								</div>
							</div>
						</div>
					</div>
					
					<div class="model">
						<div class="left"> 教育经历 </div>
						<div class="right">
							<div v-if="detail.project.length==0">未填写教育经历</div>
							<div v-for="(item,index) of detail.education" :key="index" class="li">
								<div class="cor">
									<div class="name">
										{{item.belong_to}}
										<span>{{item.position}}</span>
									</div>
									<div class="time">
										{{item.start_time}}至{{item.end_time}}
									</div>
								</div>
								<div class="praContent">
									获奖情况：{{item.descrption}}
								</div>
								<div class="reason">
									备注：{{item.remark}}
								</div>
							</div>
						</div>
					</div>
					
				</div>
				<div class="buttonG">
					<el-button v-if="is_collection==0" type="primary" plain class="buttonL" @click="coll(1)">收藏</el-button>
					<el-button v-else type="primary" class="buttonL" @click="coll(2)">已收藏</el-button>
					<el-button type="primary" class="save" @click="chatConfirm()">立即沟通</el-button>
				</div>
			</div>
			
		</div>
		
		<el-dialog
			title="发起沟通"
			:visible.sync="chatShow"
			width="400px">
			<div>
				<el-form label-width="70px">
					<el-form-item label="沟通职位">
						<el-select style="width: 100%;" v-model="position_id"  placeholder="请选择沟通的职位">
						    <el-option v-for="item in positionList" :key="item.id" :label="item.position_name" :value="item.id" />
						</el-select>
					</el-form-item>
				</el-form>
				<div style="text-align: center;margin-top: 28px;">
					<el-button @click="chatShow = false">取 消</el-button>
					<el-button type="primary" @click="toChat()">确定</el-button>
				</div>
			</div>
			
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name:'resumeDe',
		data() {
			return {
				id:'',
				detail:'',
				loading:false,
				is_collection:0,
				type:1,
				positionList:[],
				position_id:'',
				chatShow:false,
			}
		},
		created() {
			this.id=this.$route.query.id
			this.type=this.$route.query.type
			this.getDetail()
			this.getMyPosition()
		},
		methods: {
			chatConfirm(){
				this.position_id = ''
				this.chatShow = true
			},
			async toChat(){
				if(!this.position_id) return this.$eltips('请选择沟通的职位','warning')
				await this.$store.dispatch('checkoutConversation', {
					conversationID:`C2C${this.detail.user_im_account}`,
					position_id:this.position_id
				})
				this.$router.push({ name: 'communication'});
			},
			getMyPosition(){
				let data = {
					status:0,
					no_page:1
				}
				this.$axios.get('/api/client/ES/getPositionList',{params:data}).then(res=>{
					if(res.code==200){
						this.positionList = res.data
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			getDetail(){
				this.loading = true
				this.$axios.get('/api/client/ES/talentPoolDetails',{params:{id:this.id}}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.detail=res.data
						this.is_collection=res.is_collection
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			// 收藏与取消
			coll(type) {
				this.loading = true
				let data = {
					user_id: this.detail.id,
					type: type
				}
				this.$axios.post('/api/client/ES/userCollections', data).then(res => {
					this.loading = false
					if (res.code == 200) {
						if (type == 1) {
							this.is_collection = 1
						}
						if (type == 2) {
							this.is_collection = 0
						}
						this.$eltips(res.msg)
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			openPosition(){
				// this.$router.push({ name: 'positionDe',query: {id:this.detail.id,type:2 } });
			}
		}
	}
</script>

<style lang="scss" scoped>
	.resumeDe{
		position: relative;
		padding: 24px 0;
		min-height:801px ;
		box-sizing: border-box;
		.resumeDeCon{
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;
			.head{
				padding: 28px 38px;
				background-color: #FFF;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-radius: 16px;
				margin-bottom: 24px;
				.left{
					display: flex;
					align-items: center;
					color: #151515;
					.name{
						font-size: 28px;
						margin-right: 38px;
					}
					.info{
						font-size: 20px;
					}
				}
				.button{
					background-color: #9B6CFF;
					border: 1px solid #9B6CFF;
					width: 128px;
					height: 48px;
					border-radius: 6px;
					font-size: 16px;
				}
			}
		
		    .resume{
				display: flex;
				align-items: flex-start;
				padding: 28px 38px;
				background-color: #FFF;
				border-radius: 16px;
				
				.info{
					flex: 1;
					.basics{
						margin-bottom: 48px;
						.top{
							display: flex;
							align-items: center;
							justify-content: space-between;
							margin-bottom: 6px;
							.left{
								display: flex;
								align-items: center;
								.avatar{
									width: 58px;
									height: 58px;
									position: relative;
									margin-right: 24px;
									.photo {
										width: 100%;
										height: 100%;
										border-radius: 50%;
									}
									
									.gender {
										width: 17px;
										height: 17px;
										position: absolute;
										right: 0;
										bottom: 0;
										border-radius: 50%;
										z-index: 2;
									}
								}
								.nameOcc{
									display: flex;
									align-items: center;
									color: #151515;
									.name{
										font-size: 24px;
									}
									.occ{
										font-size: 14px;
										margin-left: 16px;
									}
								}
							}
							
							.right{
								display: flex;
								align-items: center;
								padding-right: 50px;
								.li{
									display: flex;
									align-items: center;
									font-size: 14px;
									color: #151515;
									.icon{
										width: 14px;
										height: 14px;
										margin-right: 16px;
									}
									padding:0 38px ;
									&:nth-child(2){
										border-left: 1px solid #D8D8D8;
										border-right: 1px solid #D8D8D8;
									}
									
								}
							}
						}
						.bottom{
							padding-left: 82px;
							color: #5E5E5E;
							font-size: 14px;
						}
					}
				
				    .model{
						display: flex;
						align-items: flex-start;
						margin-bottom: 48px;
						.left{
							color: #181C2E;
							font-size: 18px;
							width: 117px;
							margin-right: 48px;
							font-weight: bold;
						}
						.right{
							flex: 1;
							.li{
								margin-bottom: 48px;
								&:last-child{
									margin-bottom: 0;
								}
							}
							
							.cor {
								display: flex;
								align-items: center;
								justify-content: space-between;
								margin-bottom: 24px;
							
								.name {
									font-size: 18px;
									color: #181C2E;
									font-weight: bold;
									display: flex;
									align-items: center;
									span{
										color: #5E5E5E;
										font-size: 14px;
										margin-left: 24px;
										font-weight: 500;
									}
								}
							
								.time {
									color: #5E5E5E;
									font-size: 15px;
									display: flex;
									align-items: center;
									.icon{
										margin-left: 8px;
									}
									.el-icon-delete{
										margin-left: 8px;
										cursor: pointer;
										&:hover{
											color: red;
										}
									}
								}
							}
							
							.praPos,
							.praContent,
							.reason {
								color: #5E5E5E;
								font-size: 16px;
								margin-bottom: 24px;
							}
							
							.reason {
								margin-bottom: 0;
							}
						}
					}
				}
				
				.buttonG{
					display: flex;
					align-items: center;
					.el-button{
						width: 96px;
						height: 48px;
						border-radius: 8px;
						font-size: 16px;
					}
					.save{
						width: 128px;
						margin-left: 16px;
					}
				}
			}
		}
	}
	
</style>